import React from 'react';
import styled from '@emotion/styled';
import { ArrowUpCircle } from '@styled-icons/remix-line/ArrowUpCircle';

const BackToTopIcon = styled(ArrowUpCircle)`
  width: 3em;
  margin-left: 0px;
  margin-right: 5px;
  color: #53b2f5;
`;

const psbacktotop = () => (
    <a href="#" >
      <BackToTopIcon />Sayfa Başı
    </a>
  );

export default psbacktotop;
